module.exports = __webpack_public_path__ + "img/rb.450ad24f.png";